import Alpine from 'alpinejs';

/**
 *  Custom event listeners integration for Shadow DOM.
 *
 * Bridges HTMX HX-Trigger events (fired on document)
 * directly into the Alpine store ? no re-dispatching needed.
 *
 * @param {ShadowRoot} shadowRoot
 * @param {HTMLElement} wrapper - the #htmx-content-wrapper element
 */
export function registerCustomEventsListeners(shadowRoot, wrapper) {
    if (window._appMessagesRegistered) return;
    window._appMessagesRegistered = true;

    document.addEventListener('app:messages', (event) => {
        const messages = event.detail.value || event.detail;
        if (Array.isArray(messages)) {
            Alpine.store('messages').push(messages);
        }
    });

    // Clear banners on every HTMX swap that doesn't include new messages
    shadowRoot.addEventListener('htmx:afterSwap', () => {
        // Small delay to let app:messages fire first if present
        setTimeout(() => {
            Alpine.store('messages')._swapHandled = false;
        }, 50);
    });

    shadowRoot.addEventListener('htmx:beforeSwap', () => {
        Alpine.store('messages')._pendingSwap = true;
        Alpine.store('messages').banners = [];
    });
}